import { defineComponent as t, resolveComponent as r, openBlock as n, createBlock as c, normalizeProps as p, guardReactiveProps as s, withCtx as l, renderSlot as a, createElementVNode as i } from "vue";
import d from "../CdrIcon.vue.mjs";
import m from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const _ = t({
  name: "CheckFill",
  components: {
    CdrIcon: d
  },
  props: {
    props: {
      type: Object
    }
  }
}), f = /* @__PURE__ */ i("path", {
  role: "presentation",
  d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm4.77-13.357a1 1 0 10-1.533-1.286l-5.95 7.083-1.52-1.817a1 1 0 00-1.533 1.285l2.227 2.66a.999.999 0 001.565.1l6.743-8.025z"
}, null, -1);
function u(o, h, C, $, k, z) {
  const e = r("cdr-icon");
  return n(), c(e, p(s(o.props)), {
    default: l(() => [a(o.$slots, "default"), f]),
    _: 3
  }, 16);
}
const F = /* @__PURE__ */ m(_, [["render", u]]);
export {
  F as default
};
